export default `float e=2.,s;
  vec3 c=vec3(4.0,.1,1.5);
  p.y+=1.4;
  for(int j=0;++j<7;p=abs(p)-1.5,e/=s=min(dot(p,p),.4),p/=s);
  return (p.x+p.z)/e;
}`